import { render, staticRenderFns } from "./WorkEnvironment.vue?vue&type=template&id=12ce2ee3&scoped=true"
import script from "./WorkEnvironment.vue?vue&type=script&lang=js"
export * from "./WorkEnvironment.vue?vue&type=script&lang=js"
import style0 from "./WorkEnvironment.vue?vue&type=style&index=0&id=12ce2ee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce2ee3",
  null
  
)

export default component.exports